const CODE_DOWN = "ArrowDown";
const CODE_END = "End";
const CODE_HOME = "Home";
const CODE_LEFT = "ArrowLeft";
const CODE_PAGEDOWN = "PageDown";
const CODE_PAGEUP = "PageUp";
const CODE_RIGHT = "ArrowRight";
const CODE_UP = "ArrowUp";
const RX_UNDERSCORE = /_/g;
const RX_LOWER_UPPER = /([a-z])([A-Z])/g;
const RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
const RX_START_SPACE_WORD = /(\s|^)(\w)/g;
const RX_FIRST_START_SPACE_WORD = /(\s|^)(\w)/;
const RX_SPACE_SPLIT = /\s+/;
const RX_HASH = /^#/;
const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
const RX_SPACES = /[\s\uFEFF\xA0]+/g;
export {
  CODE_LEFT as C,
  RX_NUMBER as R,
  CODE_UP as a,
  CODE_RIGHT as b,
  CODE_DOWN as c,
  RX_UNDERSCORE as d,
  RX_LOWER_UPPER as e,
  RX_FIRST_START_SPACE_WORD as f,
  RX_SPACES as g,
  RX_START_SPACE_WORD as h,
  RX_REGEXP_REPLACE as i,
  CODE_PAGEUP as j,
  CODE_PAGEDOWN as k,
  CODE_HOME as l,
  CODE_END as m,
  RX_SPACE_SPLIT as n,
  RX_HASH_ID as o,
  RX_HASH as p
};
//# sourceMappingURL=constants-DY6pmjuU.mjs.map
